import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import Header from "../Header";
import GovernorPanel from "../components/GovernorPanel";
import "./IMessage.css";
import axios from "axios";
import API_BASE_URL from "../../config";
import {
  BsChatFill,
  BsBagPlus,
  BsLaptop,
  BsGearFill,
  BsXLg,
} from "react-icons/bs";

const getToken = () => localStorage.getItem("userToken");

export default function IMessage() {
  const navigate = useNavigate();
  const headers = useCallback(() => {
    const t = getToken();
    return t ? { Authorization: `Bearer ${t}` } : {};
  }, []);

  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notSubscribed, setNotSubscribed] = useState(false);
  const [governorFor, setGovernorFor] = useState(null);

  useEffect(() => { if (!getToken()) window.location.href = "/login"; }, []);

  const fetchAgents = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/imessage/agents`, { headers: headers(), timeout: 15000 });
      setAgents(res.data.agents || []);
      setNotSubscribed(false);
    } catch (err) {
      if (err.response?.status === 402) setNotSubscribed(true);
      else console.error("iMessage agents error:", err.message);
    } finally {
      setLoading(false);
    }
  }, [headers]);

  useEffect(() => {
    fetchAgents();
    const t = setInterval(fetchAgents, 20000);
    return () => clearInterval(t);
  }, [fetchAgents]);

  const statusInfo = (s) => {
    if (s === "online") return { label: "Connected", cls: "ok" };
    if (s === "awaiting_apple_id") return { label: "Awaiting Apple ID", cls: "pend" };
    return { label: "Offline", cls: "off" };
  };

  return (
    <div className="page-container">
      <Sidebar />
      <div className="main-content">
        <Header />
        <div className="container mt-4">
          <div className="page-header dash-head">
            <div>
              <h4>iMessage handles</h4>
              <p className="page-subtitle">Hosted iMessage — sign in with a dedicated Apple ID, no Mac required on your side.</p>
            </div>
          </div>

          {notSubscribed ? (
            <div className="im-empty">
              <BsChatFill size={48} />
              <h5>iMessage isn’t active on your account</h5>
              <p>Subscribe to the iMessage service to get a hosted handle provisioned.</p>
              <button className="im-add-btn" onClick={() => navigate("/services")}><BsBagPlus /> View iMessage plans</button>
            </div>
          ) : loading ? (
            <div className="page-loading"><div className="spinner" /><p>Loading handles…</p></div>
          ) : (
            <div className="im-grid2">
              <div className="im-card2">
                <div className="im-card2-h"><h6>Handles</h6></div>
                {agents.length === 0 ? (
                  <div className="im-empty2">
                    <BsLaptop size={30} />
                    <div><strong>No handles yet</strong><p>Hosted iMessage handles are provisioned by Pairfon. Contact support to add one.</p></div>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="im-table">
                      <thead><tr><th>Apple ID</th><th>Type</th><th>Today</th><th>Status</th><th></th></tr></thead>
                      <tbody>
                        {agents.map((a) => {
                          const st = statusInfo(a.status);
                          return (
                            <tr key={a.id}>
                              <td>
                                <div className="im-nm">{a.handle || "Not signed in yet"}</div>
                                <div className="im-sub2">{a.label || a.machine_name || "Hosted Mac"}</div>
                              </td>
                              <td className="im-mut">Hosted</td>
                              <td>{a.messages_sent_today || 0}</td>
                              <td><span className={`im-tag ${st.cls}`}>{st.label}</span></td>
                              <td className="im-actions">
                                {a.status === "online" && a.handle && (
                                  <button className="im-ic" title="Sending limits" onClick={() => setGovernorFor(a.id)}><BsGearFill /></button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <div className="im-card2">
                <div className="im-card2-h"><h6>How hosting works</h6></div>
                <div className="im-steps">
                  <div className="im-step"><span className="n">1</span><div>Pairfon provisions a dedicated <b>Mac in the cloud</b> for your account.</div></div>
                  <div className="im-step"><span className="n">2</span><div>It signs in with a <b>dedicated Apple ID</b> — no Mac required on your side.</div></div>
                  <div className="im-step"><span className="n">3</span><div>Send &amp; receive through the <b>API</b> and webhooks, with the anti-ban governor keeping volume safe.</div></div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Sending limits (governor) */}
      {governorFor && (
        <div className="modal-overlay" onClick={() => setGovernorFor(null)}>
          <div className="im-gov-modal" onClick={(e) => e.stopPropagation()}>
            <button className="im-modal-close" onClick={() => setGovernorFor(null)} aria-label="Close"><BsXLg /></button>
            <div className="im-gov-head"><BsGearFill /><h5>Sending limits</h5></div>
            <GovernorPanel channel="imessage" ownerId={governorFor} />
          </div>
        </div>
      )}
    </div>
  );
}
